import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Map } from 'immutable';

import { Table, Button, Modal, Tabs, Select } from 'antd';

import { sagaDeleteApp, sagaLoadAppOrganizations, sagaAddOrganizationToApp, sagaRemoveOrganizationFromApp } from '../actions';

import Field from '../../shared/components/Field';
import EmptyContainer from '../../shared/components/EmptyContainer';

import _ from 'lodash';

import { sortByNameAsc } from "../../organizations/utils"

const confirm = Modal.confirm;
const TabPane = Tabs.TabPane; 

export class AppsUnselected extends Component{
  render(){
    return(
      <EmptyContainer 
        title="Select an app from the sidebar or create a new app." 
        description="It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout." />
    )
  }
}

class AppContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDeleteDialog: false,
      showAddOrganizationDialog: false,
      showAppOrganizationDeleteDialog: false,
      organizationToDelete: null,
      // Organization
      selectedOrganization: '',
    }

    const DeleteOrganizationColumn = (value, record) => (
      <div>
          <Button type="danger" onClick={()=>{
            this.onShowAppOrganizationDeleteDialog(record._id);
          }} icon="close-circle">Delete Organization</Button>
      </div>
    );

    this.columns = [{
          title: 'Organization Name',
          dataIndex: 'name',
          key: 'name'
      },{
          title: 'Country',
          dataIndex: 'country',
          key: 'country',
      },
      {
          title: '',
          key: 'edit',
          render: DeleteOrganizationColumn,
      }
    ];
  }

  componentDidMount(){
    let appId = this.props.match.params.app_id;
    this.props.loadAppOrganizations(appId);
  }

  componentDidUpdate(newProps){
    if (newProps.match.params.app_id !== this.props.match.params.app_id) {
      let appId = this.props.match.params.app_id;
      this.props.loadAppOrganizations(appId);
    }
  }

  onDeleteButtonTap(){
    const self = this;
    confirm({
      title: 'Are you sure you want to delete the app?',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        self.onDeleteConfirm();
      },
      onCancel() {
      },
    });
  }

  // App organization mapping methods

  onAddOrganizationButtonTap(){
    this.setState({
      showAddOrganizationDialog: true,
    })
  }

  onShowAppOrganizationDeleteDialog(organizationId){
    this.setState({
      organizationToDelete: organizationId,
    });

    const self = this;
    confirm({
      title: 'Are you sure you want to delete the app?',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        self.onDeleteAppOrganization();
      },
      onCancel() {
      },
    });
  }
  
  onDeleteAppOrganization(){
    let appId = this.props.match.params.app_id;
    let organizationId = this.state.organizationToDelete;

    this.props.removeOrganizationFromApp(appId, organizationId);
  }
  
  onOrganizationChange(e, value){
    this.setState({
      selectedOrganization: value.key,
    });
  }

  addOrganization(){
    let appId = this.props.match.params.app_id;
    this.props.addOrganizationToApp(appId, this.state.selectedOrganization);

    this.setState({
      showAddOrganizationDialog: false,
      selectedOrganization: '',
    });
  }

  onCloseAddOrganization(){
    this.setState({
      showAddOrganizationDialog: false,
    })
  }

  onDeleteConfirm(){
    let appId = this.props.match.params.app_id;
    this.props.deleteApp(appId);

    this.setState({
      showDeleteDialog: false,
    });
  }

  render() {
    let app = this.props.appsMap[this.props.match.params.app_id];

    let appOrganizations = this.props.appOrganizations.get(this.props.match.params.app_id);

    if (_.isUndefined(appOrganizations)) appOrganizations = [];

    if (!_.isNil(app)){
      appOrganizations.sort(sortByNameAsc);
      return(
        <div>
          <div style={{ padding: '15px 15px 10px 15px'}}>
            <h3>{app.name}</h3>
          </div>
        <Tabs defaultActiveKey="details">
          <TabPane tab="Details" key="details">
            <div className="container-with-padding">
                <div>
                  <Field title="Package Name" value={app.packageName} />
                  <Field title="Description" value={app.description} />
                  <Field title="Next Rule Update Interval Formatted" value={app.nextRuleUpdateIntervalFormatted} />
                  <Field title="Distance Filter" value={`${app.distanceFilterMeters}`} />
                  <Field title="Location Ping Interval in Milliseconds" value={`${app.locationPingIntervalMS}`} />
                  <Field title="Relevance" value={`${app.relevance}`} />
                  <Field title="Should Collect Data" value={app.shouldCollectData ? "Yes": "No"} />
                  <Field title="Discovery Mode" value={`${app.discoveryMode}`} />
                  <Field title="BD API Key" value={app.apiKey} />
                  <Field title="App Secret" value={app.appSecret} />
                  <Field title="Created At" value={app.createdAt} />
                  <Field title="Updated At" value={app.updatedAt} />
                </div>
                <div style={{paddingTop: 20, paddingBottom: 10}}>
                  <Button 
                    type="danger"
                    icon="delete"
                    style={{ marginRight: 10 }}
                    onClick={this.onDeleteButtonTap.bind(this)}>
                      Delete App
                  </Button>
                  <Button 
                    type="default"
                    icon="edit">
                      Edit App
                  </Button>
                </div>
            </div>
          </TabPane>
          <TabPane tab="Organizations" key="organisations">
            <div className="container-with-padding">
                <div>
                  <div>
                    <Button 
                      type="primary" 
                      style={{ top: 10, right: 30, position: 'absolute' }}
                      icon="plus"
                      onClick={this.onAddOrganizationButtonTap.bind(this)}>Add Organization
                    </Button>
                  </div>
                  
                  <Table
                      columns={this.columns}
                      dataSource={appOrganizations}
                      rowKey={`_id`}
                      pagination={{ pageSize: 15 }} />
                </div>
                {/* Add Organization */}
                <Modal
                  title="Add Organizations to the App"
                  visible={this.state.showAddOrganizationDialog}
                  titleStyle={{margin: 0, paddingBottom: 0}}
                  onOk={this.addOrganization.bind(this)}
                  onCancel={this.onCloseAddOrganization.bind(this)}
                  okText="Add Organization to App"
                  cancelText="Close">
                  <div style = {{ padding: '20px 0px 140px 0px'}}>
                    <Select 
                      dropdownMatchSelectWidth={true}
                      style={{ width: '100%' }}
                      onChange={this.onOrganizationChange.bind(this)}
                      filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                      showSearch={true} placeholder={'Search for Organization'}>
                      {this.props.allOrganizations.map((organization) => (
                        <Select.Option key={organization._id}>
                          {`${organization.name} - ${organization.country}`}
                        </Select.Option>
                      ))}
                    </Select>
                  </div>
                </Modal>
            </div>
          </TabPane>
        </Tabs>
        </div>
      )
    }
    return null;
  }
}

AppContent.defaultProps = {
  allOrganizations: [],
}

AppContent.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      'app_id': PropTypes.string,
    })
  }),
  deleteApp: PropTypes.func,
  loadAppOrganizations: PropTypes.func,
  removeOrganizationFromApp: PropTypes.func,
  appsMap: PropTypes.object,
  addOrganizationToApp: PropTypes.func,
  appOrganizations: PropTypes.instanceOf(Map),

  allOrganizations: PropTypes.array,
}

// Map props to the store

const mapStateToProps = (state) => ({
  appsMap: state.routes.apps.get('appsMap').toObject(),
  appOrganizations: state.routes.apps.get('appOrganizationMap'),
  allOrganizations: state.common.get('organizations'),
});

const mapDispatchToProps = (dispatch) => ({
  deleteApp: (appId) => {
    dispatch(sagaDeleteApp(appId));
  },
  loadAppOrganizations: (appId) => {
    dispatch(sagaLoadAppOrganizations(appId));
  },
  addOrganizationToApp: (appId, organizationId) => {
    dispatch(sagaAddOrganizationToApp(appId, organizationId));
  },
  removeOrganizationFromApp: (appId, organizationId) => {
    dispatch(sagaRemoveOrganizationFromApp(appId, organizationId));
  }
});

const AppContentContainer = connect(mapStateToProps,mapDispatchToProps)(AppContent);

export default AppContentContainer;


// WEBPACK FOOTER //
// ./src/apps/components/AppsContent.js